import { render, staticRenderFns } from "./UiExportMenuButton.vue?vue&type=template&id=8803495c&scoped=true"
import script from "./UiExportMenuButton.vue?vue&type=script&lang=js"
export * from "./UiExportMenuButton.vue?vue&type=script&lang=js"
import style0 from "./UiExportMenuButton.vue?vue&type=style&index=0&id=8803495c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8803495c",
  null
  
)

export default component.exports